import {
  MarketingConversationTopic,
  QueueType,
} from "@redotech/redo-marketing-common/conversation/marketing-conversation-definition";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const getQueueCount = {
  name: "getQueueCount" as const,
  input: z.object({
    queueType: createEnum(QueueType).default(QueueType.Default).optional(),
    currentQueueTopic: createEnum(MarketingConversationTopic).optional(),
  }),
  output: z.object({ count: z.number() }),
};
